module.exports = __webpack_public_path__ + "h5/img/logo2.7a052e76.png";